// Hook para verificar permissões do usuário
import { useState, useEffect } from 'react';
import { useEmpresa } from '../contexts/EmpresaContext';
import { getRoleUsuarioEmpresa } from '../services/usuariosService';

export type Role = 'admin' | 'operador' | 'visualizador';

interface Permissions {
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  canView: boolean;
  role: Role | null;
  loading: boolean;
}

export function usePermissions(): Permissions {
  const { empresaSelecionada } = useEmpresa();
  const [role, setRole] = useState<Role | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadRole() {
      if (!empresaSelecionada) {
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const userRole = await getRoleUsuarioEmpresa(empresaSelecionada.id);
        setRole(userRole);
      } catch (error) {
        console.error('Erro ao carregar role:', error);
        setRole(null);
      } finally {
        setLoading(false);
      }
    }

    loadRole();
  }, [empresaSelecionada]);

  // Visualizadores podem apenas ver
  // Operadores podem criar, atualizar e ver, mas não deletar
  // Admins podem tudo
  const canCreate = role === 'admin' || role === 'operador';
  const canUpdate = role === 'admin' || role === 'operador';
  const canDelete = role === 'admin';
  const canView = role !== null;

  return {
    canCreate,
    canUpdate,
    canDelete,
    canView,
    role,
    loading,
  };
}






